import React, { createContext, useContext, useReducer, useEffect } from 'react';
import axios from 'axios';
import api from '../service/api';


const AuthContext = createContext();


const initialToken = localStorage.getItem('token');
console.log('AuthContext: Initializing with token from localStorage:', initialToken);
const initialState = {
  user: null,
  token: initialToken,
  loading: true,
  isAuthenticated: false
};


const AUTH_SUCCESS = 'AUTH_SUCCESS';
const AUTH_FAIL = 'AUTH_FAIL';
const LOGOUT = 'LOGOUT';
const SET_LOADING = 'SET_LOADING';

const authReducer = (state, action) => {
  switch (action.type) {
    case AUTH_SUCCESS:
      return {
        ...state,
        user: action.payload.user,
        token: action.payload.token,
        isAuthenticated: true,
        loading: false
      };
    case AUTH_FAIL:
      return {
        ...state,
        user: null,
        token: null,
        isAuthenticated: false,
        loading: false
      };
    case LOGOUT:
      return {
        ...state,
        user: null,
        token: null,
        isAuthenticated: false,
        loading: false
      };
    case SET_LOADING:
      return {
        ...state,
        loading: action.payload
      };
    default:
      return state;
  }
};


export const AuthProvider = ({ children }) => {
  const [state, dispatch] = useReducer(authReducer, initialState);

  
  useEffect(() => {
    if (state.token) {
      axios.defaults.headers.common['Authorization'] = `Bearer ${state.token}`;
    } else {
      delete axios.defaults.headers.common['Authorization'];
    }
  }, [state.token]);

  
  useEffect(() => {
    const loadUser = async () => {
      const storedToken = localStorage.getItem('token');
      console.log('AuthContext: loadUser - Stored token:', storedToken);
      if (storedToken) {
        try {
          const res = await api.get('/api/users/profile');
          console.log('AuthContext: loadUser - User profile fetched:', res.data);
          dispatch({
            type: AUTH_SUCCESS,
            payload: {
              user: res.data,
              token: storedToken
            }
          });
        } catch (error) {
          console.error('AuthContext: loadUser - Error fetching user profile:', error);
          localStorage.removeItem('token');
          dispatch({ type: AUTH_FAIL });
        }
      } else {
        console.log('AuthContext: loadUser - No token found in localStorage.');
        dispatch({ type: AUTH_FAIL });
      }
    };

    loadUser();
  }, []);

  
  const login = async (email, password) => {
    try {
      const res = await api.post('/api/auth/login', { email, password });
      
      console.log('AuthContext: Login - response user:', res.data.user);
      localStorage.setItem('token', res.data.token);
      console.log('AuthContext: Login - Token saved to localStorage:', res.data.token);
      
      dispatch({
        type: AUTH_SUCCESS,
        payload: {
          user: res.data.user,
          token: res.data.token
        }
      });

      return { success: true };
    } catch (error) {
      dispatch({ type: AUTH_FAIL });
      return { 
        success: false, 
        message: error.response?.data?.message || 'Login failed' 
      };
    }
  };

  
  const register = async (userData) => {
    try {
      const res = await api.post('/api/auth/register', userData);
      
      localStorage.setItem('token', res.data.token);
      
      dispatch({
        type: AUTH_SUCCESS,
        payload: {
          user: res.data.user,
          token: res.data.token
        }
      });

      return { success: true };
    } catch (error) {
      dispatch({ type: AUTH_FAIL });
      return { 
        success: false, 
        message: error.response?.data?.message || 'Registration failed' 
      };
    }
  };


  const logout = () => {
    localStorage.removeItem('token');
    dispatch({ type: LOGOUT });
  };

  return (
    <AuthContext.Provider
      value={{
        ...state,
        login,
        register,
        logout
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};


export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};
